import React from "react";
import { gridStyles } from "../GridStyles";
export default function ColumnResizer(props) {
    const styles = gridStyles();
    return React.createElement("span", { ...(props.allowResize && props.column.getResizerProps()), className: "resizeHandle data-grid", style: styles.resizeHandle });
}
ColumnResizer.defaultProps = {
    allowResize: true
};
